<template>
  <v-dialog
    v-model="$store.state.help"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card dark color="primary">
        <v-toolbar-title v-t="'help.title'"></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="$store.commit('toggleHelp')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-list three-line subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title v-t="'help.creator'"></v-list-tile-title>
              <v-list-tile-sub-title v-t="'help.creator_name'"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title v-t="'help.creator_address'"></v-list-tile-title>
              <v-list-tile-sub-title><a href="vipstarcoin:VUmino3VbniKFyCzgYwpt8ZWfWumLGzSX4?message=Thank%20you%20using%20VIPSTARCOIN%20QRCode%20Generator%21">VUmino3VbniKFyCzgYwpt8ZWfWumLGzSX4</a></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title v-t="'help.girls_icon_creator'"></v-list-tile-title>
              <v-list-tile-sub-title><a href="vipstarcoin:VXbFLe5T5dZrAoCFb5tGRY8iA2HvrU5fBs">VXbFLe5T5dZrAoCFb5tGRY8iA2HvrU5fBs</a></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title v-t="'help.bba_icon_creator'"></v-list-tile-title>
              <v-list-tile-sub-title><a href="vipstarcoin:VKC9v8gATzvv3ua1WrYquKGr6mXoNWCtAW">VKC9v8gATzvv3ua1WrYquKGr6mXoNWCtAW</a></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list three-line subheader>
          <v-subheader v-t="'help.how_to'"></v-subheader>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-icon>language</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-t="'help.how_to_language'"></v-list-tile-title>
              <v-list-tile-sub-title v-t="'help.how_to_language_detail'"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-icon>refresh</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-t="'help.how_to_refresh'"></v-list-tile-title>
              <v-list-tile-sub-title v-t="'help.how_to_refresh_detail'"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-icon>camera_alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-t="'help.how_to_camera'"></v-list-tile-title>
              <v-list-tile-sub-title v-t="'help.how_to_camera_detail'"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-icon>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-t="'help.how_to_help'"></v-list-tile-title>
              <v-list-tile-sub-title v-t="'help.how_to_help_detail'"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HelpDialog.vue